import { sendMessage, listenToMessages } from "../../wsFunctions/socket";
import { useEffect } from "react";

function StatusStudentPage(props) {
    const status = props.status;
    const green = "22, 255, 18";
    const yellow = "255, 251, 18";

    const containerStyles = {
        border: `solid 4px rgba(${status ? green : yellow}, 1)`,
        backgroundColor: `rgba(${status ? green : yellow}, 0.2)`,
        display: ((status !== undefined) ? 'block' : "none")
    };

    const cancelRequest = () => {
        const userID = localStorage.getItem("userID");        
        sendMessage({type: "help-request-cancel", data: {userID: userID}});
    };

    useEffect(() => {
        const listner = listenToMessages((e) => {
            const type = e.data.type;
            if (type === "help-request-cancelled") {
                props.setStatus(undefined);
            };
        });

        return () => listner();
    }, [props]);

    return (
        <div id="status-student-page" style={containerStyles}>
            <b>Status:</b> <p>{status ? "Hjelp er på vei nå :)" : "Forespørsel sendt, boksen blir grønn når leksehjelp er på vei"}</p>
            <button onClick={cancelRequest} id="cancel-btn" style={{display: ((status!==undefined) ? "block" : "none")}}>Avbryt forespørsel</button>
        </div>
    );
};

export default StatusStudentPage;